<template>
    <div>
        <ShareNetwork
            ref="facebookShare"
            class="m-1"
            :url="url"
            network="facebook"
            :title="title"
            @open="runWorkaround('facebookShare')"
        >
            <img
                :src="require('@/assets/icons/facebook.png')"
                alt="Facebook"
                :style="{ width: '25px', height: '25px', borderRadius: '15%' }"
            />
        </ShareNetwork>
        <ShareNetwork
            ref="twitterShare"
            class="m-1"
            :url="url"
            network="twitter"
            :title="title"
            @open="runWorkaround('twitterShare')"
        >
            <img
                :src="require('@/assets/icons/x.jpg')"
                alt="Twitter"
                :style="{ width: '25px', height: '25px', borderRadius: '15%' }"
            />
        </ShareNetwork>
        <ShareNetwork
            ref="telegramShare"
            class="m-1"
            :url="url"
            network="telegram"
            :title="title"
            @open="runWorkaround('telegramShare')"
        >
            <img
                :src="require('@/assets/icons/telegram.png')"
                alt="Telegram"
                :style="{ width: '25px', height: '25px' }"
            />
        </ShareNetwork>
        <a class="m-1" @click="copyUrlAndOpenInstagram">
            <img
                :src="require('@/assets/icons/instagram.png')"
                alt="Instagram"
                :style="{ width: '25px', height: '25px' }"
            />
        </a>
        <ShareNetwork
            ref="whatsappShare"
            class="m-1"
            :url="url"
            network="whatsapp"
            :title="title"
            @open="runWorkaround('whatsappShare')"
        >
            <img
                :src="require('@/assets/icons/whatsapp.png')"
                alt="WhatsApp"
                :style="{ width: '26px', height: '26px' }"
            />
        </ShareNetwork>
        <ShareNetwork
            ref="emailShare"
            class="m-1"
            :url="url"
            network="email"
            :title="title"
            :subject="subject"
            :body="body"
            @open="runWorkaround('emailShare')"
        >
            <img
                :src="require('@/assets/icons/email.png')"
                alt="Email"
                :style="{ width: '26px', height: '26px' }"
            />
        </ShareNetwork>
    </div>
</template>
  
<script>
    import { ShareNetwork } from "vue-social-sharing";
  
    export default {
        props: {
            'url': String,
            'scale': String,
            'subject': String,
            'body': String,
            'title': String
        },
        components: {
            ShareNetwork,
        },
        methods: {
            runWorkaround(refName) {
                const shareNetworkRef = this.$refs[refName];
                if (shareNetworkRef && shareNetworkRef.popupInterval) {
                    clearInterval(shareNetworkRef.popupInterval);
                    shareNetworkRef.popupWindow = undefined;
                }
            },
            copyUrlAndOpenInstagram() {
                navigator.clipboard.writeText(this.url).then(
                    () => {
                        alert('Enlace copiado al portapapeles. Ahora puedes pegarlo en tu publicación de Instagram.');
                        // Abrir Instagram en una nueva pestaña
                        window.open('https://www.instagram.com/', '_blank');
                    },
                    err => {
                        console.error('Error al copiar el enlace: ', err);
                    }
                );
            },
        },
    };
</script>
  
<style scoped>
  .m-1 {
    cursor: pointer;
    margin: 0.5rem;
  }
</style>
